import React, { Component } from "react";
import Select from "react-select";
import { Button } from "carbon-components-react";
import { StepCard } from "..";
import CancelModal from "../Modal/CancelModal";
import { getDmService, getByDmService } from "../../services/Api";

class UnitsAndStores extends Component {
  constructor(props) {
    super(props);

    this.state = {
      units: [],
      stores: [],
      list: props.list || [],
      selectedUnit: null,
      selectedStore: null,
      error: null,
      cancelModal: false
    };
  }

  componentWillMount() {
    this.loadUnits();
  }

  loadUnits = async () => {
    try {
      const data = await getDmService("/Unidade?usaPrecadastro=true");
      this.setState({
        units: data.map(item => ({ id: item.id, label: item.nome }))
      });
    } catch (error) {
      console.error(error);
    }
  };

  loadStores = async unitId => {
    try {
      const data = await getByDmService("/Loja/GetByUnidade", unitId);
      this.setState({
        stores: data.map(item => ({ id: item.id, label: item.nome }))
      });
    } catch (error) {
      console.error(error);
    }
  };

  itemToString = item => (item.id ? item.label : "");

  onChangeUnit = obj => {
    this.setState({
      stores: [],
      selectedUnit: obj,
      selectedStore: null,
      error: null
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({ selectedStore: obj, error: null });
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  addItem = () => {
    const { list, selectedUnit, selectedStore } = this.state;

    const insertObj = {
      unidade: { id: selectedUnit.id, nome: selectedUnit.label },
      loja: { id: selectedStore.id, nome: selectedStore.label }
    };

    if (list.find(p => p.loja.id === insertObj.loja.id && p.unidade.id === insertObj.unidade.id)) {
      this.setState({
        error:
          "Não é possível adicionar a mesma Unidade e Loja mais de uma vez."
      });
    } else {
      this.setState(
        prevState => ({
          list: [...prevState.list, insertObj],
          isEdited: false
        }),
        () => {
          this.canSave();
        }
      );
    }
  };

  removeItem = index => {
    this.setState(prevState => {
      const newList = [...prevState.list];
      newList.splice(index, 1);
      return { list: newList, isEdited: true };
    });
  };

  canSave = () => {
    const { list } = this.state;
    const { hideActions } = this.props;

    if (list.length && hideActions) {
      return this.save();
    }

    if (!list.length) {
      return false;
    }

    return true;
  };

  save = async () => {
    const { saveStep, hideActions } = this.props;
    const { list } = this.state;
    await saveStep({
      unidadesLojas: list,
      salvouUnidades: true
    });

    if (!hideActions) {
      this.stepCardRef.toggleContent();
    }
  };

  requestCancel = () => {
    const { isEdited } = this.state;

    if (isEdited) {
      this.toggleCancelModal();
    } else {
      this.cancel();
    }
  };

  cancel = () => {
    const { list } = this.props;
    this.setState({
      list: list || [],
      isEdited: false,
      cancelModal: false
    });
    this.stepCardRef.toggleContent();
  };

  renderList = () => {
    const { list } = this.state;

    return list.map((item, index) => (
      <div
        key={`${item.unidade.id}-${item.loja.id}`}
        className="bx--col-xs-12 bx--col-sm-10"
      >
        <div className="bx--form-item--inline v-sm-margin full-width sm-padding bg-tranlucent">
          <div className="font-size-13 flexible">{`${item.unidade.nome} ${item.loja.nome ? " - " : ""} ${item.loja.nome}`}</div>
          <button
            kind="ghost"
            type="submit"
            className="button button--clear button--icon gray"
            onClick={() => this.removeItem(index)}
          >
            <i className="material-icons">remove_circle</i>
          </button>
        </div>
      </div>
    ));
  };

  renderDescription = () => {
    const { step, list } = this.props;

    if (list.length) {
      return list.map((item, index) => (
        <p
          key={item.id || index}
          className="font-size-12"
          style={{ color: "#36474f" }}
        >
          <strong>{item.unidade.nome}</strong>
          {` ${item.loja.nome ? " - " : " "} ${item.loja.nome}`}
        </p>
      ));
    }

    return step.description;
  };

  render() {
    const {
      units,
      stores,
      selectedUnit,
      selectedStore,
      error,
      cancelModal
    } = this.state;
    const {
      step,
      campaignItem,
      disabled,
      hideActions,
      salvouUnidades,
      showSave,
      titleBtnSave
    } = this.props;
    const isFinished =
      (campaignItem && campaignItem.salvouUnidades) || salvouUnidades;

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={isFinished}
        onToggle={isExpanded => isExpanded && this.loadUnits()}
        disabled={disabled}
      >
        <div className="bx--grid">
          <div className="bx--row">
            <div className="bx--col-xs-10 bx--col-sm-5">
              <label className="v-sm-margin">Unidades</label>
              <Select
                className="select-dm"
                name="units"
                options={units}
                value={selectedUnit}
                onChange={this.onChangeUnit}
                placeholder="Digite o código ou selecione"
                isClearable={false}
                isSearchable
              />
            </div>
            <div className="bx--col-xs-10 bx--col-sm-5">
              <label className="v-sm-margin">Lojas</label>
              <Select
                className="select-dm"
                name="stores"
                options={stores}
                value={selectedStore}
                onChange={this.onChangeStore}
                placeholder="Digite o código ou selecione"
                isClearable={false}
                isSearchable
              />
            </div>
            <div className="bx--col-xs-2 bx--col-sm-2">
              <button
                kind="ghost"
                type="submit"
                className="button button--clear button--icon"
                style={{ height: "35px", marginTop: "30px" }}
                onClick={this.addItem}
                disabled={!selectedUnit || !selectedStore}
              >
                <i className="material-icons">add_circle</i>
              </button>
            </div>
          </div>
          <div className="bx--row">{this.renderList()}</div>
          <div className="bx--row">
            {error && (
              <div className="bx--col-xs-12 fadeIn animated">
                <p className="text-danger font-size-12">{error}</p>
              </div>
            )}
          </div>

          {!hideActions && showSave && (
            <div className="bx--row">
              <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
                <Button onClick={this.save} disabled={!this.canSave()}>
                  {titleBtnSave || "Salvar"}
                </Button>
                <Button
                  kind="ghost"
                  className="h-sm-margin"
                  onClick={this.requestCancel}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          )}

          <CancelModal
            open={cancelModal}
            onOk={this.cancel}
            onCancel={this.toggleCancelModal}
          />
        </div>
      </StepCard>
    );
  }
}

export default UnitsAndStores;



// WEBPACK FOOTER //
// ./src/components/campaigns/UnitsAndStores.js